import React, { createContext, useState } from "react";

// Create context for Client data
export const ClientContextApi = createContext();

const ClientContext = ({ children }) => {
  // Client global state
  const [clientData, setClientData] = useState({});
  const [offset, setOffset] = useState(0);
  const [allOffset, setAllOffset] = useState([0]);
  const [clientCount, setClientCount] = useState(0);
  const [newClientCount, setNewClientCount] = useState(0);
  const [deletedClientCount, setDeletedClientCount] = useState(0);

  // Set Client data into client State(clientData)
  const updateClientState = (newData, page) => {
    setClientData({ ...clientData, [page]: newData });
  };

  const setAllOffsetState = (newOffset) => {
    setAllOffset((prevState) => [...prevState, newOffset]);
  };

  // Set offset into offSet State(offset)
  const updateClientOffset = (newOffset) => {
    setOffset(newOffset);
  };

  // Set client list count into client State(clientCount)
  const updateClientCount = (data) => {
    setClientCount(data);
  };

  // Edit client and update client list
  const editClientList = (editedClient) => {
    setClientData({});
    setAllOffset([0]);
  };

  // Set current client data after delete functionality
  const deleteClientData = (newClientData) => {
    setClientData({});
    setAllOffset([0]);
  };

  // Edit client and update client list
  const addNewClient = (newClientData) => {
    setClientData({});
    setAllOffset([0]);
  };

  return (
    <ClientContextApi.Provider
      value={{
        clientData,
        offset,
        clientCount,
        newClientCount,
        deletedClientCount,
        updateClientState,
        updateClientOffset,
        deleteClientData,
        editClientList,
        addNewClient,
        updateClientCount,
        setNewClientCount,
        setDeletedClientCount,
        setAllOffsetState,
        allOffset,
      }}
    >
      {children}
    </ClientContextApi.Provider>
  );
};

export default ClientContext;
